import React, { useState } from 'react';
import Modal from '../../components/Modals/Modal';
import ReactSelect from '../../components/Inputs/ReactSelect';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import useScript from '../../hooks/useScript';
import useClinics from '../../store/clinics/clinicsContext';

function AddAppointmentModal({
  showAddAppointment,
  setShowAddAppointment,
  treatmentCollaborators,
  treatmentInfo,
  addAppointment,
  fetchAppointments
}) {


  const {
    getPartnerClinics
  } = useClinics();

  const [ selectedCollaborator, setSelectedCollaborator] = React.useState({
        partnerId: null,
        partnerName: null,
        email: null,
        url: ''
    });

    const selectPartnerOptions = [];
    treatmentCollaborators.map(partner => {
      return selectPartnerOptions.push({
      label: partner.user_id.first_name + ' ' + partner.user_id.last_name, 
      value: partner.user_id._id, 
      email: partner.user_id.email, 
      url: partner.user_id.calendly.scheduling_url 
    })
  });

  const [clinics, setClinics] = useState([])
  const [selectedClinic, setSelectedClinic] = useState({})

  React.useEffect(() => {
    if (selectedCollaborator.partnerId) getPartnerClinics(selectedCollaborator.partnerId).then(res => setClinics(res || []));
    
  }, [selectedCollaborator]);


  const selectCoEOptions = [];
  if (clinics.length) clinics.forEach(center => selectCoEOptions.push({label: center.name, value: center._id}));
  

  useScript('https://assets.calendly.com/assets/external/widget.js');

  function isCalendlyEvent(e) {
    return e.data.event && e.data.event.indexOf('calendly') === 0;
  };

  const eventHandler = (e) => {
    if (isCalendlyEvent(e)) {
      if (e.data.event === 'calendly.event_scheduled') {
        const eventUri = e.data.payload.event.uri;
        const lastIndex = eventUri.lastIndexOf('/');
        const eventId = eventUri.substring(lastIndex + 1, eventUri.length);
        const appointmentData = {
          treatmentId: treatmentInfo._id,
          partnerId: selectedCollaborator.partnerId,
          appointmentId: eventId
        }
        addAppointment(appointmentData).then(() => {
          fetchAppointments();
        })
      }
      }
  }

  React.useEffect(() => {
    window.removeEventListener('message', eventHandler);
    window.addEventListener('message', eventHandler);
    return () => {
      window.removeEventListener('message', eventHandler);
    }
  }, [selectedCollaborator]);
    

  const handleCancelAddAppointment = () => {
    setShowAddAppointment(false);
    setSelectedCollaborator({
      partnerId: null,
      partnerName: null,
      email: null,
      url: ''
    });
  }

  const getLocationDetails = () => {
    let clinicDetails = clinics.filter((c)=>c._id == selectedClinic.id)
    if(clinicDetails && clinicDetails[0]){
      let location = clinicDetails[0].location
      let address = location.address ? location.address + ', ' : ''
      let city = location.city ? location.city + ', ' : ''
      let country= location.country ? location.country + ', ' : ''
      let postal_code = location.postal_code ? location.postal_code : ''
      return `${address} ${city} ${country} ${postal_code}`
    }
    return null
  } 

  const handleScheduleAppointmentClick = () => {
    window.Calendly.initPopupWidget({
      url: selectedCollaborator.url  + `?location=${getLocationDetails()}`,
      prefill: {
        name: `${treatmentInfo.patient_id.first_name} ${treatmentInfo.patient_id.last_name}`,
        email: `${treatmentInfo.patient_id.email}`,
      },
    });
    return false;
  }

  return (
    <Modal title={'Add appointment'} show={showAddAppointment} hide={handleCancelAddAppointment}>
      <div className='flex flex-col'>
        <div className='grid grid-cols-1 gap-y-1 my-8'>
          <span>Please select a collaborator:</span>
          <ReactSelect 
            options={selectPartnerOptions} 
            value={selectedCollaborator.partnerName}
            onChange={(e) => setSelectedCollaborator({ partnerName: e.label, partnerId: e.value, email: e.email, url: e.url })}
          />
        </div>
        <div className='flex flex-col'>
        {
         selectedCollaborator.partnerId && !selectedCollaborator.url &&
          <p className='text-center flex text-secondary'>Selected collaborator does not have an associated Calendly account</p>
        }
        {
           selectedCollaborator.partnerId &&  selectedCollaborator.url && <div className='grid grid-cols-1 gap-y-1'>
           <span>Please select a clinic:</span>
           <ReactSelect 
            id='centerOfExcellenceName' 
            options={selectCoEOptions} 
            value={selectedClinic.name}
            onChange={(e) => setSelectedClinic({name: e.label, id: e.value})}
          /> 
         </div>
        }
        </div>
        <div className='grid grid-cols-2 gap-x-2 mt-10'>
          <SecondaryButton onClick={handleCancelAddAppointment} text='Cancel'/>
          <PrimaryButton disabled={selectedCollaborator.url && selectedClinic.id ? false : true} onClick={handleScheduleAppointmentClick} text='Add appointment'/>
        </div>
      </div>
    </Modal>
  )
}

export default AddAppointmentModal;
